module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS44NDcwMSAwTDkuMDYzMjggMy4xMzUwNUw1LjkyODEzIDYuMjcwMUwyLjc5MzEgNy4wNTM5Nkw1LjM3NDAyIDkuNjM0OTFMMC4xMTcxODggMTQuODkxOEwxLjIyNTM5IDE2TDYuNDgyMjMgMTAuNzQzMUw5LjA2MzI4IDEzLjMyNDFMOS44NDcwMSAxMC4xODlMMTIuOTgyIDcuMDUzOTZMMTYuMTE3MiA2LjI3MDFMOS44NDcwMSAwWiIgZmlsbD0iI0NGQ0ZDRiIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homebase/bookmarks/pin-inactive.svg
// module id = zeny
// module chunks = 1